export { View as Journal } from './view'
